import { useEffect } from "react";

import { useCreateClubModal } from "../../components/Clubs/createClub/CreateClubModalContext";

/**
 * Compatibility route for `/clubs/new` (bookmarks, old links).
 * Opens the global create-club modal; closing navigates to Discover if still on this path.
 */
export default function CreateClubPage() {
  const { openCreateClubModal } = useCreateClubModal();

  useEffect(() => {
    openCreateClubModal();
  }, [openCreateClubModal]);

  return null;
}
